import styled from 'styled-components';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { TextMain } from '../../../components/typography/Texts';
import { theme } from '../../../assets/styles/theme';

type FieldStatus = 'READ_ONLY' | 'EDITION';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  height: 20px;
`;

const IconWrapper = styled.div`
  cursor: pointer;
`;

const Input = styled.input`
  background-color: ${theme.color.lighterGray};
  font-size: ${theme.font.size.s};
  align-items: center;
  line-height: 2.2rem;
  letter-spacing: -0.4px;
  border: 0;
  outline: 0;
  padding-left: 0;
`;

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const UserNameField = ({ value, onChange }: Props) => {
  const [status, setStatus] = useState<FieldStatus>('READ_ONLY');
  const [newValue, setNewValue] = useState(value);

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  const handleChange = () => {
    setStatus('READ_ONLY');
    onChange(newValue);
  };

  const handleClose = () => setStatus('READ_ONLY');

  const handleEdit = () => setStatus('EDITION');

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleChange();
    }
  };

  if (status === 'READ_ONLY') {
    return (
      <Container>
        <TextMain>{value}</TextMain>
        <IconWrapper onClick={handleEdit}>
          <EditIcon style={{ fontSize: 16 }} />
        </IconWrapper>
      </Container>
    );
  } else {
    return (
      <Container>
        <Input
          autoFocus={true}
          value={newValue}
          onChange={event => setNewValue(event.target.value)}
          onKeyDown={handleKeyDown}
        />
        <IconWrapper onClick={handleClose}>
          <CloseIcon style={{ fontSize: 20 }} />
        </IconWrapper>
        <IconWrapper onClick={handleChange}>
          <CheckIcon style={{ fontSize: 20 }} />
        </IconWrapper>
      </Container>
    );
  }
};

export default UserNameField;
